import { ALL_COMPANIES_OPTION } from 'utils/partnerUtils'

import { PLAN_TYPES } from 'containers/App/constants'
import {
  selectActualIntegrations,
  selectActualLicenses,
  selectIsStaticSalesDemo,
  selectPartner,
} from 'containers/App/selectors'
import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'
import {
  selectData as selectListData,
  selectUrlState,
} from 'containers/ResolutionCenter/List/selectors'
import {
  QUICK_FILTER,
  QUICK_FILTER_OPTIONS_ALL,
  QUICK_FILTER_OPTIONS_BY_URL_STATE,
} from 'containers/ResolutionCenter/QuickFilters/constants'
import { selectData as selectReportedIncidentsData } from 'containers/ResolutionCenter/ReportedIncidents/selectors'

const selectQuickFilters = (state) => state.resolutioncenter.quickFilters.quickFilters

const showAllQuickFilters = (state) => {
  const licenses = selectActualLicenses(state)
  const integrations = selectActualIntegrations(state)
  const isReportedIncidents = !selectUrlState(state)
  const relevantData = isReportedIncidents
    ? selectReportedIncidentsData(state)
    : selectListData(state)
  const hasAtoOrTeamsReport = relevantData.hasAtoReport || relevantData.hasTeamsReport

  if (selectPartner(state) && selectCompanyFilter(state)?.value === ALL_COMPANIES_OPTION.value) {
    return true
  }

  if (
    integrations.o365 &&
    (licenses.plan === PLAN_TYPES.EMAIL_PROTECT || licenses.plan === PLAN_TYPES.STARTER) &&
    (!licenses.ato || !licenses.teams || !hasAtoOrTeamsReport)
  ) {
    return true
  }
  return false
}

const selectQuickFilterOptions = (state) => {
  const urlState = selectUrlState(state)
  const licenses = selectActualLicenses(state)
  const integrations = selectActualIntegrations(state)
  const isStaticSalesDemo = selectIsStaticSalesDemo(state)

  const relevantData = !urlState ? selectReportedIncidentsData(state) : selectListData(state)

  let options = QUICK_FILTER_OPTIONS_BY_URL_STATE[urlState]

  if (!options) options = QUICK_FILTER_OPTIONS_ALL // Reported Incidents Page

  if (!showAllQuickFilters(state)) {
    if (!integrations.o365 && !licenses.ato && !relevantData.hasAtoReport) {
      options = options.filter(
        (e) => e.value !== QUICK_FILTER.ATO && e.value !== QUICK_FILTER.COMPROMISED
      )
    }
    if (
      (!licenses.teams && !isStaticSalesDemo) ||
      integrations.gmail_serverside ||
      integrations.gmail_webhooks
    ) {
      options = options.filter((e) => e.value !== QUICK_FILTER.TEAMS)
    }
  }

  return options
}

export { selectQuickFilters, selectQuickFilterOptions, showAllQuickFilters }
